import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=a48e20bc&"
import script from "./Allocation.vue?vue&type=script&lang=js&"
export * from "./Allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a48e20bc')) {
      api.createRecord('a48e20bc', component.options)
    } else {
      api.reload('a48e20bc', component.options)
    }
    module.hot.accept("./Allocation.vue?vue&type=template&id=a48e20bc&", function () {
      api.rerender('a48e20bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/Allocation.vue"
export default component.exports